// extracted by mini-css-extract-plugin
export default {"modal":"Alert_modal__yhfOB","footer":"Alert_footer__0uDTm","deleteConfirm":"Alert_deleteConfirm__demLd","cancelButton":"Alert_cancelButton__FGOkv"};